import { Link } from 'react-router-dom';
import '../styles/Header.css';

function Header({ home }) {
  return (
    <nav className="site-nav">
      <Link className="site-nav-brand" to="/">
        <img src="/logo.png" alt="Sadguru Flower" className="site-nav-logo" />
      </Link>

      {home ? (
        <>
          <ul className="site-nav-links">
            <li><a href="#features">Features</a></li>
            <li><a href="#how-it-works">How it works</a></li>
            <li><a href="#reviews">Reviews</a></li>
            <li><Link to="/contact">Contact</Link></li>
          </ul>
          <div className="site-nav-cta">
            <a className="btn-primary" href="#download">
              <i className="ti ti-download" style={{fontSize:'16px'}}></i>
              Download the app
            </a>
          </div>
        </>
      ) : (
        <Link className="nav-back" to="/">
          <i className="ti ti-arrow-left" style={{fontSize:'15px'}}></i>
          Back to home
        </Link>
      )}
    </nav>
  );
}

export default Header;
